module.exports = {"licenseYear":2024}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 960
// module chunks = 0